import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { stripHtml, cleanTitle } from '../../utils/helpers';
const BlogMain = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const wpUrl = process.env.REACT_APP_WP_URL;
  useEffect(() => {
    async function fetchBlogPosts() {
      try {
        setLoading(true);

        // Get category slug from URL path
        const path = location.pathname;
        const parts = path.split('/').filter(Boolean); // e.g. ['event-news', 'texas-events']
        const categorySlug = parts[1] || 'blog'; // if no slug, fallback to 'blog'

        // 1. Get category by slug
        const catRes = await fetch(`${wpUrl}wp-json/wp/v2/categories?slug=${categorySlug}`);
        const catData = await catRes.json();
        if (catData.length === 0) throw new Error(`Category "${categorySlug}" not found`);

        const categoryId = catData[0].id;

        // 2. Get child categories
        const childrenRes = await fetch(`${wpUrl}wp-json/wp/v2/categories?parent=${categoryId}`);
        const childrenData = await childrenRes.json();
        const childIds = childrenData.map(cat => cat.id);
        const allIds = childIds.length ? `${categoryId},${childIds.join(',')}` : `${categoryId}`;

        // 3. Fetch posts in parent + children
        const postsRes = await fetch(`${wpUrl}wp-json/wp/v2/posts?categories=${allIds}&_embed`);
        const postsData = await postsRes.json();

        setPosts(postsData);
      } catch (err) {
        console.error('Error fetching blog posts:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchBlogPosts();
  }, [location.pathname]);


   const generateBlogSchema = (posts) => {
    const schema = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "Blog List",
      "itemListElement": posts.map((post, index) => {
        const featuredMedia = post._embedded?.['wp:featuredmedia']?.[0];
        const imageUrl = featuredMedia?.source_url || '';

        return {
          "@type": "BlogPosting",
          "@id": `https://www.rsvppass.com/event-news-details/${post.slug}`,
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": `https://www.rsvppass.com/event-news-details/${post.slug}`
          },
          "headline": stripHtml(post.title.rendered),
          "image": imageUrl,
          "datePublished": post.date,
         
          "publisher": {
            "@type": "Organization",
            "name": "RSVPPASS",
            "logo": {
              "@type": "ImageObject",
              "url": "https://www.rsvppass.com/rsvp_logo.png"
            }
          },
          "description": stripHtml(post.excerpt?.rendered || '').substring(0, 160)
        };
      })
    };

    return JSON.stringify(schema, null, 2);
  };

  if (loading) return <p>Loading...</p>;

  

  return (
    <React.Fragment>
      <section className="blog-page">
  <div className="container">
    <div className="row">
      {posts.length === 0 ? (
        <div className="col-12">
          <p className="text-center">No blog posts found for this category.</p>
        </div>
      ) : (
        posts.map((post) => {
          const featuredMedia = post._embedded?.['wp:featuredmedia']?.[0];
          const imageUrl = featuredMedia?.source_url || '';

          return (
            <div
              className="col-xl-4 col-lg-4 col-md-6 wow fadeInUp"
              data-wow-delay="200ms"
              key={post.id}
            >
              <div className="blog-one__single">
                <div className="blog-one__img">
                  <img src={imageUrl} alt={post.title.rendered} loading="lazy" 
                                 srcSet={`
                                      ${featuredMedia?.source_url}?w=400 400w,
                                      ${featuredMedia?.source_url}?w=600 600w,
                                      ${featuredMedia?.source_url}?w=800 800w
                                    `}/>
                  <div className="blog-one__hover">
                    <Link to={`/event-news-details/${post.slug}`}>
                      <div className="blog-one__hover-icon-1">
                        <span className="blog-one__hover-icon-2"></span>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="blog-one__content">
                  <ul className="blog-one__meta list-unstyled">
                    {/* <li>
                      <Link to="#">
                        <span className="icon-user"></span> By{" "}
                        {post._embedded?.author?.[0]?.name || 'Unknown'}
                      </Link>
                    </li> */}
                    <li>
                      <Link to="#">
                        <span className="icon-calendar"></span>{" "}
                        {new Date(post.date).toLocaleDateString()}
                      </Link>
                    </li>
                  </ul>
                  <h3 className="blog-one__title">
                    <Link
                      to={`/event-news-details/${post.slug}`}
                      dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                    />
                  </h3>
                  <div className="blog-one__btn-box-two">
                    <Link
                      to={`/event-news-details/${post.slug}`}
                      className="blog-one__btn-2 thm-btn"
                    >
                      Read More
                      <span className="icon-arrow-right"></span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  </div>
</section>
 {posts.length > 0 && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: generateBlogSchema(posts) }}
          
        />
      )}
    </React.Fragment>
  );
};

export default BlogMain;
